<template lang="pug">
  .root
    the-heading(:caption="results.short_name" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption {{results.short_name}}
        .item_container
          .item
            .item_header Полное наименование
            .item_value {{results.name}}
          .item
            .item_header OID
            .item_value(v-if="results.oid") {{results.oid}}
            .item_value.empty(v-if="!results.oid") —
          .item
            .item_header Версия
            .item_value(v-if="results.version") {{results.version}}
            .item_value.empty(v-if="!results.version") —
          .item
            .item_header Дата изменения
            .item_value {{results.modified_date | date}}
          .item
            .item_header Альтернативное наименование
            .item_value(v-if="results.alternative_name") {{results.alternative_name}}
            .item_value.empty(v-if="!results.alternative_name") —
          .item
            .item_header Группа
            .item_value {{'Cправочники Webiomed'}}
          .item
            .item_header Тип Доступа
            .item_value {{results.is_public ? 'Общедоступный' : null}}
          .item
            .item_header Псевдоним
            .item_value {{results.alias}}
          .item
            .item_header Краткое наименование
            .item_value {{results.short_name}}
          .item(id="organization")
            .item_header Ответственная организация
            .item_value {{results.organization ? results.organization_text : 'Отсутствует'}}
          .item(id="description")
            .item_header Описание
            .item_value(id="description" v-if="results.description") {{results.description}}
            .item_value.empty(v-if="!results.description") —
          .item(id="legal_act")
            .item_header Нормативно правовой акт
            .item_value(v-if="results.legal_act") {{results.legal_act}}
            .item_value.empty(v-if="!results.legal_act") —
        //- button(@click="showAdditional = !showAdditional")
          span(v-show="!showAdditional") Показать ещё
          span(v-show="showAdditional") Скрыть
        .grid
          FilterFields(:fields="filters" :count="count" :className="className")
          .table
            page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count" :editable="results.is_editable_values")
</template>
<script>
import directorySummaryMixin from '@/mixins/directorySummaryMixin'
import breadcrumbs from '@/data/breadcrumbs/DirectorySummary'
import FilterFields from '@/components/parts/FilterFields'
import TheHeading from '@/components/parts/TheHeading'
import PageGrid from '../parts/PageGrid'
import axios from 'axios'

export default {
  components: {
    FilterFields,
    breadcrumbs,
    TheHeading,
    PageGrid
  },
  mixins: [directorySummaryMixin],
  created () {
    axios
      .get('dhra/api/v2/nsi/directories/' + this.$route.params.id + '/')
      .then(
        values => {
          this.results = values.data
          document.title = this.results.short_name
          axios
            .get(
              'dhra/api/v2/nsi/directory-organizations/' + this.results.organization + '/'
            )
            .then(result => {
              this.results.organization_text = result.data.name
            })
          this.alias = this.results.alias
          this.address = this.setAddress()
          this.cols = this.setCols()
          this.filters = this.setFilters()
          this.className = this.setClass()
        }
      )
      .then(resolve => {
        this.getData()
        this.filter = {}
      })
    localStorage.removeItem('sParams')
  },
  data () {
    return {
      searchParams: new URLSearchParams(),
      filter: this.$route.query,
      breadcrumbs,
      limit: 25,
      offset: 0,
      maxPages: 7,
      maxSize: [],
      page: 1,
      buffer: 3,
      cols: null,
      data: null,
      alias: null,
      address: null,
      nextState: 'DirectoryEdit',
      count: '',
      className: '',
      filters: {},
      results: [],
      showAdditional: false,
      findKey: false
    }
  },
  methods: {
    pressEnter () {
      this.$refs.grid.spinnerON = true
      this.getData()
    },
    getData (filter) {
      if (this.findKey) this.offset = 0
      this.page = this.offset !== 0 ? this.offset / this.limit + 1 : 1
      let par1 = 0
      let par2 = 0
      if (
        this.page > this.buffer &&
        this.page < this.maxPages - this.buffer + 1
      ) {
        par1 = this.page - this.buffer
        par2 = this.page + this.buffer + 1
      } else {
        if (this.page <= this.buffer) {
          par1 = 1
          par2 = 2 + this.buffer * 2
        }
        if (this.page >= this.maxPages - this.buffer + 1) {
          par1 = this.maxPages - 2 * this.buffer
          par2 = this.maxPages + 1
        }
      }
      if (filter) this.filter = filter
      for (let key in this.filter) {
        if (!this.filter[key]) {
          delete this.filter[key]
        }
      }
      if (this.defaultParams) {
        this.filter = Object.assign(this.filter, this.defaultParams)
      }
      this.$router.push({ query: this.filter })
      this.searchParams = new URLSearchParams()
      if (Object.keys(this.$route.query).length) {
        Object.keys(this.$route.query).forEach(key => {
          this.searchParams.append(key, this.$route.query[key])
        })
      }

      axios
        .get(this.address + this.searchParams + '&limit=' + this.limit + '&offset=' + this.offset)
        .then(values => {
          this.count = values.data.count
          this.maxPages = Math.ceil(values.data.count / this.limit)
          let par1 = 0
          let par2 = 0
          if (this.page > this.buffer && this.page < this.maxPages - this.buffer + 1) {
            par1 = this.page - this.buffer
            par2 = this.page + this.buffer + 1
          } else {
            if (this.page <= this.buffer) {
              par1 = 1
              par2 = 2 + this.buffer * 2
            }
            if (this.page >= this.maxPages - this.buffer + 1) {
              par1 = this.maxPages - 2 * this.buffer
              par2 = this.maxPages + 1
            }
          }
          this.maxSize = []
          for (
            let index = this.maxPages > 6 ? par1 : 1;
            index < (this.maxPages > 6 ? par2 : this.maxPages + 1);
            index++
          ) {
            this.maxSize.push(index)
          }
          this.setData(values.data.results)
          this.$refs.grid.spinnerON = false
          this.findKey = false
        })
    },
    find () {
      this.getData()
    },
    clear () {
      this.filter = {}
      this.getData()
    },
    nextPage () {
      this.offset = this.offset + this.limit
      this.$refs.grid.spinnerON = true
      this.getData()
    },
    prevPage () {
      this.offset = this.offset - this.limit
      this.$refs.grid.spinnerON = true
      this.getData()
    },
    goToFirstPage () {
      this.offset = 0
      this.$refs.grid.spinnerON = true
      this.getData()
    },
    goToLastPage () {
      this.offset = this.limit * (this.maxPages - 1)
      this.$refs.grid.spinnerON = true
      this.getData()
    },
    goToPage (page) {
      this.offset = this.limit * (page - 1)
      this.$refs.grid.spinnerON = true
      this.getData()
    }
  }
}
</script>
<style lang="sass" scoped>
//MAIN
.container
  min-height: 100vh
  color: black
  background: #f7f7f0
  display: flex
  align-items: flex-start
  justify-content: center
.main_block
  min-height: 100vh
  background: white
  margin: 55px 0
  width: 1400px
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2)
.localCaption
  margin-left: 40px
  margin-top: 50px

//DATA
.item_container
  margin: 40px 60px 0 40px
  display: grid
  grid-template-columns: repeat(4, 1fr)
  grid-column-gap: 5%
.item
  margin-bottom: 20px
.item_header
  font-size: 14px
  font-weight: 500
  color: #555
  margin-bottom: 5px
.item_value
  background: #ebf7f9
  margin-top: 2px
  font-size: 14px
  font-weight: 400
  color: #212121
  min-width: 100%
  border-radius: 10px
  padding: 3px 10px
.empty
  background: #f7fcfc
#organization
  grid-column: 2 / span 2
#description
  grid-column: 1 / span 4
#legal_act
  grid-column: 1 / span 4
// GRID
.grid
  margin-top: 40px

// ANIMATION
.fade-enter-active, .fade-leave-active
  transition: opacity .6s
.fade-enter, .fade-leave-to
  opacity: 0

// MEDIA
@media screen and (max-width: 1133px)
  .table
    margin-left: 30px
@media screen and (max-width: 1150px)
  .item_container
    grid-template-columns: repeat(3, 1fr)
  #organization
    grid-column: 1 / span 3
  #description
    grid-column: 1 / span 3
  #legal_act
    grid-column: 1/ span 3
  .container
    justify-content: left
@media screen and (max-width: 900px)
  .item_container
    grid-template-columns: repeat(2, 1fr)
  #organization
    grid-column: 1 / span 2
  #description
    grid-column: 1 / span 2
  #legal_act
    grid-column: 1/ span 2
</style>
